export default {
invoice_history: "Invoice History",
search_invoice: "Search Invoice / Order / Restaurant...",
from: "From",
to: "To",
invoice_id: "Invoice ID",
order_id: "Order ID",
restaurant: "Restaurant",
date: "Date",
total: "Total",
status: "Status",
action: "Action",
view: "View",
no_invoices: "No invoices found",

generated: "Generated",
unpaid: "Unpaid",
paid: "Paid",
invoice_details: "Invoice Details",
supplier_details: "Supplier Details",
restaurant_details: "Restaurant Details",
products: "Products",
payment_details: "Payment Details",
download_pdf: "Download Invoice PDF",
pdf_error: "Failed to download PDF",
store: "Store",
contact: "Contact",
mobile: "Mobile",
email: "Email",
address: "Address",
name: "Name",
qty: "Qty",
price: "Price",
discount: "Discount",
}